<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter Foreign Address Details</h5>
    <form [formGroup]="addressForm" novalidate>
        <div class="row mx-0 mt-5">
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                <div class="form-floating mb-md-4 mb-3">
                    <select class="form-select" tabindex="1"
                        [ngClass]="addressForm.controls.DocType.value ? 'optionValue has-value' : ''"
                        formControlName="DocType" id="docType" (change)="docError = false; checkType($event)">
                          <!-- <option value="" disabled selected>Select Foreign Address Proof Type</option> -->
                        <option *ngFor="let list of docTypeList; let i = index" [value]="list.DocumentTypeId">
                            {{list.Name}}</option>
                    </select>
                    <label for="docType" [ngClass]="addressForm.controls.DocType.value ? '':'form-select-label'">Select
                        Foreign Address Proof Type <span class="text-danger">*</span></label>
                    <small class="text-danger ms-2" *ngIf="addressForm.controls.DocType.value === '8'">
                        Documents not less than 2 months<sup>*</sup>
                    </small>
                    <small class="text-danger ms-2 fw-bold" *ngIf="this.ProofName === 'Bank Statement'">
                        Latest 2 months Bank statement with 2 customer-initiated Transaction’s mandatory<sup>*</sup>
                    </small>
                    <div class="text-danger small my-4" *ngIf="docError">
                        Please select document type
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                <div class="form-floating mb-md-4 mb-3">
                    <select class="form-select text-uppercase" tabindex="2" formControlName="Country" id="country"
                        [ngClass]="addressForm.controls.Country.value ? 'has-value':''">
                        <option [value]="list.Name" *ngFor="let list of countryList; let i = index">{{list.Name}}
                        </option>
                    </select>
                    <label for="country" [ngClass]="addressForm.controls.Country.value ? '':'form-select-label'">Select
                        Country <span class="text-danger">*</span></label>
                </div>
            </div>

        </div>

        <div class="row mx-0 mt-3">
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                <div class="form-floating"
                    [ngClass]="addressForm.controls.AddressLine1.touched && addressForm.controls.AddressLine1.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" tabindex="3" class="form-control" formControlName="AddressLine1"
                        [ngClass]="addressForm.controls.AddressLine1.value ? 'has-value':''" autocomplete="off"
                        maxlength="100" minlength="5" id="adr1" placeholder="Address Line 1"
                        (input)="onInputChanged($event)">
                    <label for="adr1">Enter Address Line 1 <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.AddressLine1.touched && addressForm.controls.AddressLine1.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter address line 1.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-3 order-md-0">
                <div class="form-floating" tabindex="6"
                    [ngClass]="addressForm.controls.State.touched && addressForm.controls.State.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase"
                        [ngClass]="addressForm.controls.State.value ? 'has-value':''" formControlName="State"
                        autocomplete="off" maxlength="45" id="state" placeholder="State"
                        (input)="onInputChange($event)">
                    <label for="state">Enter State <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.State.touched && addressForm.controls.State.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter State name.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                <div class="form-floating"
                    [ngClass]="addressForm.controls.AddressLine2.touched && addressForm.controls.AddressLine2.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" tabindex="4" class="form-control" formControlName="AddressLine2"
                        [ngClass]="addressForm.controls.AddressLine2.value ? 'has-value':''" autocomplete="off"
                        maxlength="100" minlength="5" id="adr2" placeholder="Address Line 2"
                        (input)="onInputChanged($event)">
                    <label for="adr2">Enter Address Line 2<span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.AddressLine2.touched && addressForm.controls.AddressLine2.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter address line 2.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-4 order-md-0">
                <div class="form-floating" tabindex="7"
                    [ngClass]="addressForm.controls.City.touched && addressForm.controls.City.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="City"
                        [ngClass]="addressForm.controls.City.value ? 'has-value':''" autocomplete="off" maxlength="45"
                        id="city" placeholder="City" (input)="onInputChange($event)">
                    <label for="city">Enter City <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.City.touched && addressForm.controls.City.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter city name.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                <div class="form-floating"
                    [ngClass]="addressForm.controls.AddressLine3.touched && addressForm.controls.AddressLine3.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" tabindex="5" class="form-control" formControlName="AddressLine3"
                        [ngClass]="addressForm.controls.AddressLine3.value ? 'has-value':''" autocomplete="off"
                        maxlength="100" minlength="5" id="adr3" placeholder="Address Line 3"
                        (input)="onInputChanged($event)">
                    <label for="adr3">Enter Address Line 3 <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.AddressLine3.touched && addressForm.controls.AddressLine3.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter address line 3.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-5 order-md-0">
                <div class="form-floating"
                    [ngClass]="addressForm.controls.PinCode.touched && addressForm.controls.PinCode.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" tabindex="8" class="form-control"
                        [ngClass]="addressForm.controls.PinCode.value ? 'has-value':''" formControlName="PinCode"
                        autocomplete="off" maxlength="10" id="PinCode" placeholder="Pin Code"
                        (input)="alphaNumeric($event)" (blur)="spaceValidation($event, 'PinCode')">
                    <label for="PinCode">Enter Pincode\ZIP code
                        <span class="text-danger">*</span>
                    </label>
                    <small class="ms-2 fs-12">If there is no Pin code /P.O Box no. /ZIP code, Mention '1' for 6 times.
                    </small>
                    <div *ngIf="addressForm.controls.PinCode.touched && addressForm.controls.PinCode.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter Pincode\ZIP code.</span>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-5 order-md-0">
                <div class="form-floating"
                    [ngClass]="addressForm.controls.DocNumber.touched && addressForm.controls.DocNumber.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" tabindex="9" class="form-control"
                        [ngClass]="addressForm.controls.DocNumber.value ? 'has-value':''" formControlName="DocNumber"
                        autocomplete="off" maxlength="20" id="DocNumber" placeholder="Document Number"
                        (input)="alphaNumeric($event)" (blur)="spaceValidation($event, 'DocNumber')">
                    <label for="DocNumber">Enter Address Proof Number
                        <span class="text-danger">*</span>
                    </label>
                    <div *ngIf="addressForm.controls.DocNumber.touched && addressForm.controls.DocNumber.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please Enter Address Proof Number.</span>
                    </div>
                </div>
            </div> -->
            
        </div>
    
    </form>
    <div class="row mx-0 mt-0" >
        <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-5 order-md-0" *ngIf="AddrProofNum">
  <div class="form-floating mb-4 mb-md-5">
    <input
      type="text"
      tabindex="9"
      class="form-control"
      id="DocNumber"
      name="DocNumber"
      maxlength="20"
      placeholder="Document Number"
      autocomplete="off"
      [(ngModel)]="docNumber"
      #docNumberRef="ngModel"
      required
      (input)="alphaNumeric($event)"
      (blur)="spaceValidation($event, 'DocNumber')"
    >
    <label for="DocNumber">
      Enter Address Proof Number <span class="text-danger">*</span>
    </label>

    <div *ngIf="docNumberRef.touched && docNumberRef.invalid" class="ms-3 mt-0">
      <span class="small text-danger">Please Enter Address Proof Number.</span>
    </div>
  </div>
</div>
<div class="col-lg-6 pe-md-5" *ngIf="datesection">
                <div class="input-group border form-floating mb-4 rounded-2">
                    <input class="form-control ms-0 my-1 border-0 pe-0 py-0" [(ngModel)]="lastArrivalDt" readonly
                        placeholder="Expiry Date" ngx-mydatepicker (click)="dp.toggleCalendar()"
                        name="mydate" [options]="options2" [defaultMonth]="defaultMonth.defMonth" id="pExpiry"
                        #dp="ngx-mydatepicker" (dateChanged)="onDateArrival($event)" required />
                    <label for="pExpiry">Select Expiry Date<span class="text-danger">*</span></label>
                    <span class="px-3 py-2">
                        <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                    </span>
                </div>
                <div *ngIf="arrivalDateError">
                    <span class="small text-danger">Expiry Date should be above 60 days.</span>
                </div>
            </div>
            <div class="col-lg-12 pe-md-5" >
        <p class="text-danger fw-bold">*All Documents in Language other than English / Foreign language, kindly upload English Translated copy mandatorily</p>
    </div>
    </div>
    <div class="row mx-0 mt-4">
        <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
            <div>
                <nri-app-img-upld *ngIf="!previousDocs" [imageName]="'Foreign Address Front'"
                    [docTypeID]="addressForm.controls.DocType.value" (docTypeError)="typeError($event)"
                    (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #foAdrimg
                    [changeID]="changeIDs"></nri-app-img-upld>
                <div *ngIf="previousDocs"
                    class="drop-container flex-column d-flex justify-content-center text-center mb-4">
                    <p class="upload-button mt-2 mb-2 px-2 small">
                        Since you have already uploaded your {{docName}}, re-uploading the document is not necessary.
                    </p>
                </div>
                <div class="text-danger small mb-4" *ngIf="foAdrImgempty">
                    Please upload your address proof front image
                </div>
            </div>
        </div>
        <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
            <div>
                <nri-app-img-upld *ngIf="!previousDocs" [imageName]="'Foreign Address Back'"
                    [docTypeID]="addressForm.controls.DocType.value" (docTypeError)="typeError($event)"
                    (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #foAdrimg
                    [changeID]="changeIDs"></nri-app-img-upld>
                <div *ngIf="previousDocs"
                    class="drop-container flex-column d-flex justify-content-center text-center mb-4">
                    <p class="upload-button mt-2 mb-2 px-2 small">
                        Since you have already uploaded your {{docName}}, re-uploading the document is not necessary.
                    </p>
                </div>
                <div class="text-danger small mb-4" *ngIf="foAdrImgemptyBack">
                    Please upload your address proof back image
                </div>
            </div>
        </div>
        <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
            <div>
                <nri-app-img-upld [additionalImageName]="'Additional'" [imageName]="'ForeignAddrAdd'"
                    [docTypeID]="addressForm.controls.DocType.value" (getdocTypeID)="getID($event)"
                    (imageURL)="imageURL($event)" #foAdrimg [changeID]="changeIDs"></nri-app-img-upld>
            </div>
        </div>

    </div>
    <div class="d-flex align-items-end  mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" [disabled]="!addressForm.valid" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>

<!-- REDIRECTION POPUP -->

<div class="modal fade" id="redirect" tabindex="1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0">
                <p class="h5">Welcome to SBI Securities</p>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <strong>You are not allowed to continue this Journey! If you select Passport as your
                            Document!</strong>
                    </div>
                </div>
            </div>
            <div class="modal-footer row mx-0">
                <div class="col-6 m-0">
                    <!-- <button type="button" class="btn btn-google px-4 fw-bold w-100 py-2" data-bs-dismiss="modal">NO</button> -->
                </div>
                <div class="col-md-6 m-0">
                    <button type="button" class="btn btn-primary px-4 fw-bold w-100 py-2" data-bs-dismiss="modal"
                        (click)="goTo()">Click To Change</button>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>